export enum VideoEndpointsEnum {
  COMMENTS = "video/sessions/:sessionId/comments",
  DELETE_COMMENTS = "video/sessions/comments/:commentId",
}
